import React, { FC } from 'react';
import { ReactComponent as Cashback } from '../../../assets/Cashback/cashback.svg';

export const CashbackItemIcon: FC = () => <Cashback />;
